(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if(location.hash === '#modal_your-gls') {
            document.querySelector('a[href="#modal_your-gls"').click()
        }
    })
}) ()
